import {dynamicWrapper, createRoute} from '@/utils/core';

const routesConfig = (app) => ({
  path: '/crud',
  title: 'DBAdmin - Columns示例',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default (app) => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/Business/CRUD/index.js